module.exports = __webpack_public_path__ + "static/media/template6-carousel.7d451256.webp";